import { Grid } from '@mui/material'
import { getDOTRejectionReasonTypes } from 'controllers/conformity/index'
import { getConformity } from 'controllers/vehicles/conformity/index'
import { VehicleConformityDetailsDto, VehicleSendBackToCanadaDto } from 'dtos'
import { DOTRejectionReasonTypeDto } from 'dtos/conformity'
import { VehicleConformityDOTRejectionDto } from 'dtos/vehicles/conformity'
import { VehicleConformityDto } from 'dtos/vehicles/conformity/VehicleConformityDto'
import { useEffect, useState } from 'react'
import ConformityDetailsCard from './ConformityDetailsCard'
import DOTRejectionCard from './DOTRejectionCard'
import SendBackToCanadaCard from './SendBackToCanadaCard'

interface ConformityTabProps {
  vehicleGuid?: string
}

export default function ConformityTab({ vehicleGuid }: ConformityTabProps) {
  const [conformityDetails, setConformityDetails] = useState<VehicleConformityDetailsDto | undefined>(undefined)
  const [dotRejection, setDOTRejection] = useState<VehicleConformityDOTRejectionDto | undefined>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [sendBackToCanada, setSendBackToCanada] = useState<VehicleSendBackToCanadaDto | undefined>(undefined)
  const [dotRejectionReasonTypes, setDOTRejectionReasonTypes] = useState<DOTRejectionReasonTypeDto[]>([])

  useEffect(() => {
    if (!vehicleGuid) return

    getDOTRejectionReasonTypes().then(res => setDOTRejectionReasonTypes(res.value))

    setIsLoading(true)
    getConformity(vehicleGuid)
      .then(res => setState(res.value))
      .finally(() => setIsLoading(false))
  }, [vehicleGuid])

  const setState = (conformity: VehicleConformityDto) => {
    if (conformity.conformityDetails) {
      setConformityDetails(conformity.conformityDetails)
    }
    if (conformity.dotRejection) {
      setDOTRejection(conformity.dotRejection)
    }
    if (conformity.sendBackToCanada) {
      setSendBackToCanada(conformity.sendBackToCanada)
    }
  }

  return (
    <Grid container alignItems='flex-start'>
      <Grid item sm={12} md={4}>
        <ConformityDetailsCard conformityDetails={conformityDetails} isLoading={isLoading} setState={setState} vehicleGuid={vehicleGuid} />
      </Grid>

      <Grid item sm={12} md={4}>
        <DOTRejectionCard
          dotRejection={dotRejection}
          dotRejectionReasonTypes={dotRejectionReasonTypes}
          isLoading={isLoading}
          setState={setState}
          vehicleGuid={vehicleGuid}
        />
      </Grid>

      <Grid item sm={12} md={4}>
        <SendBackToCanadaCard isLoading={isLoading} sendBackToCanada={sendBackToCanada} setState={setState} vehicleGuid={vehicleGuid} />
      </Grid>
    </Grid>
  )
}
